"use client";
import { FaMagnifyingGlass as o, FaTable as e, FaTelegram as n, FaBriefcase as a, FaRegFilePdf as r, FaSlack as u, FaDiscord as i, FaDiscourse as t, FaFilePdf as l, FaChevronUp as I, FaChevronRight as F, FaPenToSquare as L, FaSort as h, FaBlog as c, FaPencil as m, FaEnvelope as p, FaPhone as C, FaChrome as O, FaStackOverflow as s, FaDatabase as k, FaGithub as D, FaBook as b } from "../../node_modules/.pnpm/react-icons@5.4.0_react@19.0.0/node_modules/react-icons/fa6/index.js";
import { FiEdit as f } from "../../node_modules/.pnpm/react-icons@5.4.0_react@19.0.0/node_modules/react-icons/fi/index.js";
import { IoOpenOutline as w, IoMail as S, IoHomeOutline as d, IoCheckmarkDoneOutline as g, IoPencilOutline as T, IoPlayCircleOutline as P, IoTerminal as R, IoLogoGithub as B, IoLogoDiscord as v, IoChatbubblesOutline as y, IoDocumentTextOutline as U, IoPeopleOutline as G, IoHelpBuoyOutline as x, IoReaderOutline as M, IoBookOutline as q, IoCheckmarkOutline as A, IoCloseOutline as E, IoReturnDownForward as H, IoChevronForwardOutline as j, IoReturnDownBackOutline as z, IoCopy as J, IoCopyOutline as K, IoSearch as N, IoThumbsDownSharp as Q, IoThumbsUpSharp as V, IoLinkOutline as W, IoInformationCircleOutline as X, IoSend as Y, IoDocumentSharp as Z, IoDocumentTextSharp as _ } from "../../node_modules/.pnpm/react-icons@5.4.0_react@19.0.0/node_modules/react-icons/io5/index.js";
import { LuCornerDownRight as $, LuSparkles as oo, LuLoaderCircle as eo, LuChevronDown as no, LuBookOpen as ao, LuArrowUpRight as ro, LuUser as uo, LuUsers as io, LuThumbsUp as to, LuThumbsDown as lo, LuRepeat as Io, LuLink as Fo, LuGlobe as Lo, LuCornerDownLeft as ho, LuCheck as co, LuCopy as mo, LuCommand as po, LuCircleCheck as Co, LuArrowLeft as Oo } from "../../node_modules/.pnpm/react-icons@5.4.0_react@19.0.0/node_modules/react-icons/lu/index.js";
const fo = {
  FaBook: b,
  FaGithub: D,
  FaDatabase: k,
  FaStackOverflow: s,
  FaChrome: O,
  FaPhone: C,
  FaEnvelope: p,
  FaPencil: m,
  FaBlog: c,
  FaSort: h,
  FaPenSquare: L,
  FaChevronRight: F,
  FaChevronUp: I,
  FaFilePdf: l,
  FaDiscourse: t,
  FaDiscord: i,
  FaSlack: u,
  IoDocumentTextSharp: _,
  IoDocumentSharp: Z,
  IoSend: Y,
  IoInformationCircleOutline: X,
  IoLinkOutline: W,
  IoThumbsUpSharp: V,
  IoThumbsDownSharp: Q,
  IoSearch: N,
  IoCopyOutline: K,
  IoCopy: J,
  IoReturnDownBackOutline: z,
  IoChevronForwardOutline: j,
  IoReturnDownForward: H,
  IoCloseOutline: E,
  IoCheckmarkOutline: A,
  IoBookOutline: q,
  IoReaderOutline: M,
  IoHelpBuoyOutline: x,
  IoPeopleOutline: G,
  IoDocumentTextOutline: U,
  IoChatbubblesOutline: y,
  FaRegFilePdf: r,
  IoLogoDiscord: v,
  IoLogoGithub: B,
  IoTerminal: R,
  FaBriefcase: a,
  IoPlayCircleOutline: P,
  IoPencilOutline: T,
  IoCheckmarkDoneOutline: g,
  IoHomeOutline: d,
  IoMail: S,
  IoOpenOutline: w,
  FaTelegram: n,
  FaTable: e,
  FaMagnifyingGlass: o,
  LuArrowLeft: Oo,
  LuCircleCheck: Co,
  LuCommand: po,
  LuCopy: mo,
  LuCheck: co,
  LuCornerDownLeft: ho,
  LuGlobe: Lo,
  LuLink: Fo,
  LuRepeat: Io,
  LuThumbsDown: lo,
  LuThumbsUp: to,
  LuUsers: io,
  LuUser: uo,
  LuArrowUpRight: ro,
  LuBookOpen: ao,
  LuChevronDown: no,
  LuLoaderCircle: eo,
  FiEdit: f,
  LuSparkles: oo,
  LuCornerDownRight: $
};
export {
  fo as iconMap
};
